// eslint-disable-next-line import/no-cycle
import {

    SETTING_CREATE_PROMOTION_CATEGORY,
    SETTING_CREATE_PROMOTION_CATEGORY_SUCCESS,
    SETTING_UPDATE_PROMOTION_CATEGORY,
    SETTING_UPDATE_PROMOTION_CATEGORY_SUCCESS,
    SETTING_LOAD_PROMOTION_CATEGORY,
    SETTING_LOAD_PROMOTION_CATEGORY_SUCCESS,
    SETTING_DELETE_PROMOTION_CATEGORY,
    SETTING_DELETE_PROMOTION_CATEGORY_SUCCESS,

    SETTING_LOAD_PROMOTION,
    SETTING_LOAD_PROMOTION_SUCCESS,
    SETTING_CREATE_PROMOTION,
    SETTING_CREATE_PROMOTION_SUCCESS,
    SETTING_UPDATE_PROMOTION,
    SETTING_UPDATE_PROMOTION_SUCCESS,
    SETTING_DELETE_PROMOTION,
    SETTING_DELETE_PROMOTION_SUCCESS,
    // SETTING_UPDATE_PROMOTION_STATUS,
    // SETTING_UPDATE_PROMOTION_STATUS_SUCCESS,

} from '../../actions';

// // -------------------- getPromotionCategory --------------------- //
export const getPromotionCategory = (data, token) => ({
    type: SETTING_LOAD_PROMOTION_CATEGORY,
    payload: data,
    token
});
export const getPromotionCategorySuccess = (data, list) => ({
    type: SETTING_LOAD_PROMOTION_CATEGORY_SUCCESS,
    payload: data,
    payloadlist: list
});

// // -------------------- createPromotionCategory --------------------- //
export const addPromotionCategory = (data, token) => ({
    type: SETTING_CREATE_PROMOTION_CATEGORY,
    payload: data,
    token
});
export const addPromotionCategorySuccess = () => ({
    type: SETTING_CREATE_PROMOTION_CATEGORY_SUCCESS,
});

// // -------------------- updatePromotionCategory --------------------- //
export const updatePromotionCategory = (data, token) => ({
    type: SETTING_UPDATE_PROMOTION_CATEGORY,
    payload: data,
    token
});
export const updatePromotionCategorySuccess = () => ({
    type: SETTING_UPDATE_PROMOTION_CATEGORY_SUCCESS,
});

// // -------------------- deletePromotionCategory --------------------- //
export const deletePromotionCategory = (data, token) => ({
    type: SETTING_DELETE_PROMOTION_CATEGORY,
    payload: data,
    token
});
export const deletePromotionCategorySuccess = () => ({
    type: SETTING_DELETE_PROMOTION_CATEGORY_SUCCESS,
});

// // -------------------- getPromotion --------------------- //
export const getPromotion = (data, token) => ({
    type: SETTING_LOAD_PROMOTION,
    payload: data,
    token
});
export const getPromotionSuccess = (data, list) => ({
    type: SETTING_LOAD_PROMOTION_SUCCESS,
    payload: data,
    payloadlist: list
});

// // -------------------- createPromotion --------------------- //
export const createPromotion = (data, token) => ({
    type: SETTING_CREATE_PROMOTION,
    payload: data,
    token
});
export const createPromotionSuccess = () => ({
    type: SETTING_CREATE_PROMOTION_SUCCESS,
});

// // -------------------- updatePromotion --------------------- //
export const updatePromotion = (data, token) => ({
    type: SETTING_UPDATE_PROMOTION,
    payload: data,
    token
});
export const updatePromotionSuccess = () => ({
    type: SETTING_UPDATE_PROMOTION_SUCCESS,
});

// // -------------------- deletePromotion --------------------- //
export const deletePromotion = (data, token) => ({
    type: SETTING_DELETE_PROMOTION,
    payload: data,
    token
});
export const deletePromotionSuccess = () => ({
    type: SETTING_DELETE_PROMOTION_SUCCESS,
});

// // -------------------- updatePromotion --------------------- //
// export const updateChangeStatusPromotion = (data, token) => ({
//     type: SETTING_UPDATE_PROMOTION_STATUS,
//     payload: data,
//     token
// });
// export const updateChangeStatusPromotionSuccess = () => ({
//     type: SETTING_UPDATE_PROMOTION_STATUS_SUCCESS,
// });
